import { NextUIProvider } from "@nextui-org/react";
import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";

import Layout from "./components/general/Layout";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import TravelAwards from "./pages/TravelAwards";
import BlogsPage from "./pages/blogs/BlogsPage";
import SingleBlogPage from "./pages/blogs/SingleBlogPage";

// asd
function App() {
  const routes = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          index: true,
          element: <HomePage />,
        },
        {
          path: "/travel-blogs",
          element: <BlogsPage />,
        },
        {
          path: "/travel-blogs/blog/:blogName",
          element: <SingleBlogPage />,
        },
        {
          path: "/about-us",
          element: <AboutPage />,
        },
        {
          path: "/travel-awards",
          element: <TravelAwards />,
        },
        {
          path: "/become-a-contester",
          element: <ContactPage />,
        },
        {
          path: "/terms-and-conditions",
          element: <TermsAndConditionsPage />,
        },
        {
          path: "/privacy-policy",
          element: <PrivacyPolicyPage />,
        },
      ],
    },
  ]);

  return (
      <NextUIProvider locale="en-GB">
        <RouterProvider router={routes} />
      </NextUIProvider>
  );
}

export default App;
